// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
import Swiper from 'swiper/bundle';
import { modal } from './components/modal/App';

// グロナビ固定
if (document.querySelector('.top-mv') !== null) {
  let gnavFixed = () => {
    const globalHeader = document.querySelector('.global-header');
    const globalHeaderShowPoint = document.querySelector('.top-mv').clientHeight;
    const scroll = document.documentElement.scrollTop;
    if (scroll > globalHeader.clientHeight) {
      globalHeader.classList.add('is-hidden');
    } else {
      globalHeader.classList.remove('is-hidden');
    }
    if (scroll >= globalHeader.clientHeight * 2) {
      globalHeader.classList.replace('is-absolute', 'is-fixed');
    } else {
      globalHeader.classList.replace('is-fixed', 'is-absolute');
    }
    if (scroll >= globalHeaderShowPoint) {
      globalHeader.classList.add('is-show');
    } else {
      globalHeader.classList.remove('is-show');
    }
  };
  window.addEventListener('load', gnavFixed);
  window.addEventListener('scroll', gnavFixed);
}

// swiper設定
if (document.querySelector('[data-role="top-mv-swiper"]') !== null) {
  const topMv = document.querySelector('[data-role="top-mv-swiper"]');

  function updateProgress(bullet) {
    let progress = 0;
    const duration = 6500;
    const startTime = performance.now();

    const animateProgress = (currentTime) => {
      // 経過時間を計算
      const elapsedTime = currentTime - startTime;

      // 経過時間に基づきprogressを更新 (0 ~ 100)
      progress = Math.min((elapsedTime / duration) * 100, 100);

      // 角度を計算
      const angle = (progress / 100) * 360;

      // conic-gradientを適用
      bullet.style.backgroundImage = `conic-gradient(
        #ea5541 0deg ${angle}deg,
        #fff ${angle}deg 360deg
      )`;

      // アニメーションが完了していなければ続行
      if (progress < 100) {
        requestAnimationFrame(animateProgress);
      }
    };

    requestAnimationFrame(animateProgress);
  }

  // eslint-disable-next-line no-new
  let topMvSwiper = new Swiper(topMv, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 1500,
    pagination: {
      el: '[data-role="top-mv-swiper-pagination"]',
      clickable: true,
    },
    on: {
      init: function () {
        this.autoplay.stop();
        setTimeout(() => {
          this.autoplay.start();
        }, 1500);
      },
      afterInit: () => {
        const activeBullet = topMv.querySelector('.swiper-pagination-bullet-active');
        if (activeBullet) {
          updateProgress(activeBullet);
        }
      },
      slideChangeTransitionStart: () => {
        const activeBullet = topMv.querySelector('.swiper-pagination-bullet-active');
        if (activeBullet) {
          updateProgress(activeBullet);
        }
      },
    },
  });
}

// Area
const topExplore = document.querySelector('.top-area');
if (topExplore !== null) {
  // 初期表示
  let defaultTemplateId;
  const exploreSwitchBtns = topExplore.querySelectorAll('.top-area-nav__btn');
  const showArea = document.querySelector('[data-role="top-area-map"]');
  exploreSwitchBtns.forEach((exploreBtn) => {
    if (exploreBtn.classList.contains('is-active')) {
      defaultTemplateId = exploreBtn.getAttribute('data-template');
    }
  });
  const defaultTemplate = document.getElementById(defaultTemplateId);
  const defaultTemplateClone = defaultTemplate.content.cloneNode(true);
  showArea.appendChild(defaultTemplateClone);

  // 要素切り替え
  const exploreSwitchArea = document.querySelector('.top-area-nav');
  exploreSwitchArea.addEventListener('click', (e) => {
    const exploreSwitch = e.target;
    if (exploreSwitch.hasAttribute('data-template')) {
      while (showArea.firstChild) {
        showArea.removeChild(showArea.firstChild);
      }
      let templateTarget;
      let activeTemplate = exploreSwitch.getAttribute('data-template');
      const showTemplate = document.getElementById(activeTemplate);
      const showTemplateClone = showTemplate.content.cloneNode(true);

      // ボタン切り替え
      exploreSwitchBtns.forEach((exploreSwitchBtn) => {
        templateTarget = exploreSwitchBtn.getAttribute('data-template');
        if (templateTarget === activeTemplate) {
          exploreSwitchBtn.classList.add('is-active');
          exploreSwitchBtn.ariaSelected = true;
        } else {
          exploreSwitchBtn.classList.remove('is-active');
          exploreSwitchBtn.ariaSelected = false;
        }
      });

      // 中身切り替え
      showArea.appendChild(showTemplateClone);
    }
  });
}

// Pick up
if (document.querySelector('[data-role="top-pickup-swiper"]') !== null) {
  // eslint-disable-next-line no-new
  let topPickupSwiper = new Swiper('[data-role="top-pickup-swiper"]', {
    slidesPerView: 1,
    spaceBetween: 12,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1500,
    breakpoints: {
      1012: {
        slidesPerView: 1.4,
        centeredSlides: false,
        spaceBetween: 32,
      },
    },
    navigation: {
      nextEl: '[data-role="top-pickup-swiper-nav-next"]',
      prevEl: '[data-role="top-pickup-swiper-nav-prev"]',
    },
  });
}

// Course
if (document.querySelector('[data-role="top-course-swiper"]') !== null) {
  // eslint-disable-next-line no-new
  let topCourseSwiper = new Swiper('[data-role="top-course-swiper"]', {
    slidesPerView: 1.2,
    spaceBetween: 24,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1500,
    breakpoints: {
      1012: {
        slidesPerView: 2.2,
        spaceBetween: 48,
      },
    },
    navigation: {
      nextEl: '[data-role="top-course-swiper-nav-next"]',
      prevEl: '[data-role="top-course-swiper-nav-prev"]',
    },
  });
}

// Event
let topEventSwiperElm = document.querySelector('[data-role="top-event-swiper"]');
if (topEventSwiperElm !== null) {
  // slideの個数を取得
  let swiperItems = topEventSwiperElm.querySelectorAll('.swiper-slide').length;

  if (swiperItems < 3) {
    topEventSwiperElm.classList.add('no-swiper');
  } else {
    new Swiper('[data-role="top-event-swiper"]', {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,
      centerInsufficientSlides: true,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 1500,
      breakpoints: {
        1012: {
          slidesPerView: 'auto',
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: '[data-role="top-event-swiper-nav-next"]',
        prevEl: '[data-role="top-event-swiper-nav-prev"]',
      },
    });
  }
}

// AI協調フィルタリング
const aiRecommend = document.querySelector('#top-ai-recommend');
if (aiRecommend) {
  $.ajax({
    url: '/recommends',
    data: {
      recommend_type: 'user',
      data_id: 'top-ai-recommend',
      data_type: 'top',
    },
    beforeSend(xhr) {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    },
    type: 'GET',
    timeout: 5000,
    success: function (response) {
      const targets = document.querySelectorAll('.top-recommend-modal');
      targets?.forEach((target) => {
        modal.initializeModal(target);
      });
    },
  });
}
